import 'css-chunk:src/components/Voices/Voices.module.scss';export default {
  "Voices": "Voices-module__Voices___-VSg8",
  "allChannelControls": "Voices-module__allChannelControls___sMG08"
};